


































import { Component, Prop, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";

// Mixins
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

// Components
import CProdCustomLabelForm from "@/components/app/global/contractProducts/cProdCustomLabelForm.vue";

@Component({
  components: {
    "cprod-custom-label-form": CProdCustomLabelForm
  }
})
export default class CProdCustomLabelComponent extends Mixins(
  CProdInjectorMixin
) {
  // Refs

  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    cProdCustomLabelForm: CProdCustomLabelForm;
  };

  // Props

  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;

  // Data

  public isEnabled = false;
  public isProcessing = false;

  // Computed

  public get isVisible() {
    return !!this.cProdData.canUpdateClientLabel;
  }

  // Methods

  public async validateBeforeSubmit() {
    this.$refs.cProdCustomLabelForm.validateBeforeSubmit();
  }

  public async revertToInitialState() {
    this.$refs.cProdCustomLabelForm.revertToInitialState();
  }
}
